import { useSelector } from 'react-redux';
import useSWRImmutable from 'swr/immutable';
import { getFieldTrialsFromAPI, getFieldTrialsTypesFromAPI } from '/@/store/field-trial-network/apiProviders';
import { getSessionCountry } from '/@/store/session/selectors';

export const useFieldTrials = ({ page = 1, pageSize = 10000 }: { page?: number; pageSize?: number }) => {
    const country = useSelector(getSessionCountry);
    return useSWRImmutable({ key: 'fieldTrials', countryCode: country.code, page, pageSize }, getFieldTrialsFromAPI);
};

export const useFieldTrialsTypes = ({ page = 1, pageSize = 100 }: { page?: number; pageSize?: number }) => {
    return useSWRImmutable({ key: 'fieldTrialsType', page, pageSize }, getFieldTrialsTypesFromAPI);
};
